import { FormattedMessage, useIntl } from "react-intl";

import Button from "@components/buttons/Button";
import Tag from "@components/labels/Tag";
import Nbsp from "@components/Nbsp";
import Icon from "@components/text/Icon";
import IconBase from "@components/text/IconBase";
import BodyCopy from "@components/typography/BodyCopy";
import Heading3 from "@components/typography/Heading3";
import InternalLink from "@components/typography/InternalLink";
import useMyExpert from "@hooks/useMyExpert";
import { AutomationFragment as AutomationType } from "@typing/Generated";

type Props = {
  automation: AutomationType;
};

const AutomationStatsPanel = ({ automation }: Props) => {
  const intl = useIntl();
  const myExpert = useMyExpert();

  return (
    <>
      <Heading3>
        {automation.title}
        {automation.locked && (
          <>
            <Nbsp />
            <Icon icon="lock" />
          </>
        )}
      </Heading3>
      <div>
        {automation.live ? (
          <Tag color="secondary-500" text={intl.formatMessage({ id: "models.automation.live" })} />
        ) : (
          <Tag color="primary-300" text={intl.formatMessage({ id: "models.automation.draft" })} />
        )}
      </div>
      <div>
        <Button fill="clear" routerLink={`/${myExpert ? "expert" : "admin"}/automations/${automation.id}/edit`}>
          <IconBase icon="edit" slot="start" />
          <FormattedMessage id="dictionary.edit" />
        </Button>
      </div>
      <BodyCopy>
        <FormattedMessage
          id="models.automation.applicationCountText"
          values={{
            link: (
              <InternalLink to={`/${myExpert ? "expert" : "admin"}/automations/${automation.id}/applications`}>
                <FormattedMessage
                  id="models.automation.applicationCountLink"
                  values={{ count: automation.applicationCount }}
                />
              </InternalLink>
            )
          }}
        />
      </BodyCopy>
    </>
  );
};

export default AutomationStatsPanel;
